import { ReactComponent as Default } from "assets/markers/default.svg"
import { ReactComponent as Disabled } from "assets/markers/disabled.svg"
import { ReactComponent as Secondary } from "assets/markers/secondary.svg"
import { ReactComponent as Selected } from "assets/markers/selected.svg"
import CustomMarker from "components/Organisms/map/CustomMarker"
import React from "react"
import clsx from "utils/clsx"
import { LatLng } from "utils/custom.types"

export type MarkerType = "default" | "secondary" | "disabled" | "selected"
type CustomMarkerPinType = {
  type?: MarkerType
  label?: React.ReactNode
  renderMarker?: (marker?: any) => any
  position?: LatLng
  onClick?: any
}

function getMarkerType(type: MarkerType) {
  switch (type) {
    case "default":
      return Default
    case "secondary":
      return Secondary
    case "disabled":
      return Disabled
    case "selected":
      return Selected
    default:
      return Default
  }
}
const CustomMarkerPin = ({
  type,
  renderMarker,
  position,
  label,
  onClick,
}: CustomMarkerPinType) => {
  const Marker = getMarkerType(type)

  const renderedMarker = (
    <div
      onClick={onClick}
      className="relative"
      style={{ height: 64.8, width: 57.6 }}
    >
      <Marker width={"100%"} height="100%" />
      {label && (
        <span
          className={clsx(
            "absolute top-[9px] font-600 text-base",
            type === "secondary" ? "text-blue" : "text-green",
            typeof label === "string" && label.length === 1
              ? "left-[24px]"
              : "left-[20px]"
          )}
        >
          {label}
        </span>
      )}
    </div>
  )
  return (
    /**
     * x = width / 2
     * y ~= -height
     */
    <CustomMarker
      position={position}
      getPixelPositionOffset={() => ({ x: -29, y: -66 })}
    >
      {typeof renderMarker === "function"
        ? renderMarker(renderedMarker)
        : renderedMarker}
    </CustomMarker>
  )
}

export default CustomMarkerPin
